import { render, staticRenderFns } from "./lawyerRegister.vue?vue&type=template&id=c96ca870"
import script from "./lawyerRegister.vue?vue&type=script&lang=js"
export * from "./lawyerRegister.vue?vue&type=script&lang=js"
import style0 from "./lawyerRegister.vue?vue&type=style&index=0&id=c96ca870&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports